<template>
  <div style="position: relative;">

    <share-link v-if="!require_fast_load" animation="wobble-hor-bottom" style="position: absolute; top: 0; right: 0; z-index: 1;"></share-link>

    <div class="preview-container" v-bind:class="{ isrendered: $root.$data.fixedPreview.isRendered }">

      <div id="preview" class="preview-outer"></div>
    </div>
  </div>
</template>

<style lang="scss">
  .preview-container {
    position: relative;
    height: 0;
    /*
    Original dimensions: 950px / 250px
    Aspect Ratio = 950:250
    Percentage = (250 / 950) * 100 = 26.315789473684211
    */
    padding-bottom: 26.315789473684211%;
    .preview-outer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .sticky {
    position: fixed;
    top: 0;
    z-index: 10;
  }
</style>

<script>
  import SVG from 'svg.js'
  import '../assets/js/svg.filter'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        require_fast_load: window.RB.require_fast_load
      }
    },

    created () {
      // console.log('BP', this)
    },

    mounted () {
      let s = SVG('preview')
      if (this.require_fast_load) {
        // BandPreview load: just init SVG without rendering.
        // App.mounted() will render after loading the correct data,
        // ensuring the correct band color is shown without flicker.
        this.$root.$data.fixedPreview.draw = s
        this.$root.$data.fixedPreview.draw.viewbox(0, 0, 950, 250)
      } else {
        this.$root.$data.fixedPreview.setSVG(s)
      }
    }
  }
</script>
